(function(){
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function qsa(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Toast */
  var toast;
  function showToast(msg, withLink){
    if (!toast){
      toast = document.createElement('div');
      toast.className = 'mp-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toast.appendChild(span);
    if (withLink){
      var a = document.createElement('a');
      a.href = root + 'cart';
      a.textContent = 'Ver carrinho';
      toast.appendChild(a);
    }
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove('is-visible'); }, 5000);
  }

  function updateCount(){
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        qsa('[data-mp-cart-count]').forEach(function(el){
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      }).catch(function(){});
  }

  /* Checkout Yampi direto: ao clicar em "Finalizar a compra" (gaveta do carrinho, página do
     carrinho ou "Comprar agora"), consultamos a API do Yampi e levamos a pessoa direto ao
     checkout, sem passar de novo pela página do carrinho. Se a consulta falhar, usamos a URL
     que o Yampi já guardou ou, em último caso, a página /cart (onde o Yampi assume). */
  var YAMPI_API = 'https://api.dooki.com.br/v2/public/shopify/cart';
  function onCartPage(){ return /\/cart(\/|$|\?)/.test(window.location.pathname); }
  function withUtms(url){
    try { if (typeof window.ymp_getUrlWithUtms === 'function') return window.ymp_getUrlWithUtms(url); } catch (e) {}
    return url;
  }
  function loader(show){
    var l = document.querySelector('.yampi-loader');
    if (l) l.style.display = show ? 'block' : 'none';
  }
  function goYampi(){
    if (!window.fetch){ window.location.href = root + 'cart'; return; }
    loader(true);
    var fail = function(){
      if (window.yampiCheckoutUrl){ window.location.href = withUtms(window.yampiCheckoutUrl); return; }
      if (onCartPage()){ loader(false); return; }
      window.location.href = root + 'cart';
    };
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart || !cart.item_count) throw new Error('carrinho vazio');
        return fetch(YAMPI_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ shop: window.location.host, shopify_internal_domain: window.shopifyInternalUrl, cart_payload: cart })
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(resp){
        if (!resp || !resp.active || !resp.checkout_direct_url) return fail();
        window.location.href = withUtms(resp.checkout_direct_url);
      })
      .catch(fail);
  }
  window.mpGoYampi = goYampi;

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[name="checkout"], .cart__checkout-button, a[href$="/checkout"], .ymp_elem_mainBtn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    goYampi();
  }, true);

  /* Buy now fallback for browsers without SubmitEvent.submitter */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-mp-buy-now]');
    if (b && b.form) b.form._mpBuyNow = true;
  });

  /* AJAX add to cart */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form.matches || !form.matches('form[data-mp-ajax]')) return;
    var buyNow = (e.submitter && e.submitter.hasAttribute('data-mp-buy-now')) || form._mpBuyNow;
    form._mpBuyNow = false;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
    .then(function(r){ return r.json().then(function(d){ if (!r.ok) throw d; return d; }); })
    .then(function(){
      /* "Comprar agora" vai direto ao checkout do Yampi. */
      if (buyNow){ goYampi(); return; }
      showToast('Produto adicionado ao carrinho!', true);
      updateCount();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    })
    .catch(function(err){
      showToast((err && (err.description || err.message)) || 'Não foi possível adicionar. Tente novamente.', false);
    })
    .then(function(){ if (btn) btn.classList.remove('is-loading'); });
  });

  /* Pixel da Meta: quando um <form action="/cart/add"> é enviado, o Shopify dispara um
     AddToCart extra sem preço e sem ID do produto, além do AddToCart correto gerado pela
     requisição AJAX acima. Tiramos o action dos forms AJAX (o envio é feito pelo fetch) para
     sobrar só o evento certo. Sem fetch/FormData, o form mantém o action e funciona normalmente. */
  if (window.fetch && window.FormData){
    qsa('form[data-mp-ajax][action]').forEach(function(f){
      f.setAttribute('data-mp-action', f.getAttribute('action'));
      f.removeAttribute('action');
    });
  }

  /* Quantity selector */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-mp-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + parseInt(b.getAttribute('data-mp-step'), 10));
    input.value = v;
  });

  /* Drawer / search */
  document.addEventListener('click', function(e){
    var c = e.target.closest('[data-mp-close]');
    if (c){ var d = c.closest('details'); if (d) d.removeAttribute('open'); }
    var link = e.target.closest('.mp-drawer__panel a');
    if (link){ var dd = link.closest('details'); if (dd) dd.removeAttribute('open'); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    qsa('details[data-mp-popup][open]').forEach(function(d){
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });
  qsa('details[data-mp-popup]').forEach(function(d){
    d.addEventListener('toggle', function(){
      if (d.classList.contains('mp-drawer')){
        document.body.classList.toggle('mp-drawer-open', d.open);
        document.body.style.overflow = d.open ? 'hidden' : '';
      }
      if (d.open){
        var f = d.querySelector('input[type="search"]');
        if (f) setTimeout(function(){ f.focus(); }, 30);
      }
    });
  });

  /* Review slider */
  qsa('[data-mp-slider]').forEach(function(slider){
    var track = slider.querySelector('.mp-slider__track');
    var items = qsa(':scope > li', track);
    var dotsWrap = slider.parentNode.querySelector('.mp-dots');
    if (!track || items.length < 2){ qsa('.mp-slider__btn', slider).forEach(function(b){ b.hidden = true; }); return; }
    function step(){ return items[0].getBoundingClientRect().width + 12; }
    qsa('[data-dir]', slider).forEach(function(b){
      b.addEventListener('click', function(){
        var dir = parseInt(b.getAttribute('data-dir'), 10);
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0 });
        else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: dir * step() });
      });
    });
    if (!dotsWrap) return;
    var dots = items.map(function(_, i){
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Ir para avaliação ' + (i + 1));
      d.addEventListener('click', function(){ track.scrollTo({ left: i * step() }); });
      dotsWrap.appendChild(d);
      return d;
    });
    function sync(){
      var i = Math.round(track.scrollLeft / step());
      dots.forEach(function(d, j){ d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  });
})();
